import pdf from 'assets/pictures/export/pdf.png'
import { push } from '@lagunovsky/redux-react-router'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import Input from '../../../components/forms/Input'
import { getDate, getHour } from '../../../utils/DateUtil'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import { StyledFieldSet, StyledLegend } from 'components/StyledElements'
import Select from 'components/forms/Select'
import OperationAction from 'quality/actions/OperationAction'
import OldOperationAction from 'quality/components/operation/actions/OperationAction'
import QualityAction from 'quality/actions/QualityAction'
import { SHOW_SANDRE_CODE } from 'account/constants/AccountSettingsConstants'
import useAccountSetting from 'utils/customHook/useAccountSetting'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'

const SampleModal = ({
    isOpen = false,
    close = () => {},

    analyse = {},
}) => {
    const dispatch = useDispatch()

    const {
        cities,
        contacts,
        producers,
        laboratories,
        qualifications,
        status,
        supports,
        parameters,
        units,
        remarks,
    } = useSelector(store => ({
        cities: store.CityReducer.cities,
        contacts: store.ContactReducer.contacts,
        producers: store.ContributorReducer.producers,
        laboratories: store.ContributorReducer.laboratories,
        qualifications: store.QualityReducer.qualifications,
        status: store.QualityReducer.status,
        supports: store.SupportReducer.supports,
        parameters: store.ParameterReducer.parameters,
        units: store.UnitReducer.units,
        remarks: store.OperationReducer.remarks,
    }), shallowEqual)

    const generalShowSandreCode = useApplicationSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : true)
    const showSandreCode = useAccountSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : generalShowSandreCode)

    const [operation, setOperation] = useState({})
    const [sample, setSample] = useState({})
    const [qualitometer, setQualitometer] = useState({})

    useEffect(() => {
        if (isOpen) {
            OperationAction.getOperation(analyse.operation, analyse.qualitometer).then(setOperation)
            OldOperationAction.promiseSample(analyse.qualitometer, analyse.operation).then(setSample)
            QualityAction.promiseQualitometer(analyse.qualitometer).then(setQualitometer)
        } else {
            setOperation({})
            setSample({})
            setQualitometer({})
        }
    }, [analyse.operation, analyse.qualitometer, isOpen])

    return (
        <Dialog
            maxWidth='xl'
            fullWidth
            PaperProps={{
                sx: {
                    minHeight: 'auto',
                    maxHeight: 'auto',
                },
            }}
            open={isOpen}
        >
            <DefaultDialogTitle title={i18n.resultDetails} onClose={close} />

            <DialogContent sx={{ overflowX: 'hidden' }}>
                <Grid container columnSpacing={2}>
                    <Grid size={6}>
                        <StyledFieldSet>
                            <StyledLegend>{i18n.station}</StyledLegend>
                            <Grid container columnSpacing={2}>
                                <Grid size={4}>
                                    <Input
                                        title={i18n.stationCode}
                                        value={qualitometer.code}
                                        disabled
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <Input
                                        title={i18n.creationDate}
                                        value={getDate(qualitometer.creation)}
                                        disabled
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <Input
                                        title={i18n.closeDate}
                                        value={getDate(qualitometer.close)}
                                        disabled
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Select
                                        options={cities}
                                        value={qualitometer.townCode}
                                        label={i18n.city}
                                        disabled
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Select
                                        options={contacts}
                                        value={qualitometer.contactCode}
                                        label={i18n.contact}
                                        disabled
                                    />
                                </Grid>
                            </Grid>
                        </StyledFieldSet>
                    </Grid>
                    <Grid size={6}>
                        <StyledFieldSet>
                            <StyledLegend>{i18n.sample}</StyledLegend>
                            <Grid container columnSpacing={2}>
                                <Grid size={3}>
                                    <Input
                                        title={i18n.date}
                                        value={getDate(operation.date)}
                                        disabled
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <Input
                                        title={i18n.hour}
                                        value={getHour(operation.date)}
                                        disabled
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <Input
                                        title={i18n.analysisNumber}
                                        value={sample.laboNumber}
                                        disabled
                                    />
                                </Grid>
                                <Grid size={2}>
                                    {sample.producerRef ? <img className='clickable right' style={{ height: '42px', paddingRight: '10px' }} src={pdf} /> : null}
                                </Grid>
                                <Grid size={12}>
                                    <Select
                                        options={producers}
                                        value={operation.producer}
                                        label={i18n.producer}
                                        disabled
                                    />
                                </Grid>
                            </Grid>
                        </StyledFieldSet>
                    </Grid>
                    <Grid size={12}>
                        <StyledFieldSet>
                            <StyledLegend>{i18n.result}</StyledLegend>
                            <Grid container columnSpacing={2}>
                                <Grid size={2}>
                                    <Input
                                        title={i18n.date}
                                        value={getDate(analyse.analysisDate)}
                                        disabled
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <Select
                                        options={supports}
                                        value={operation.support}
                                        label={i18n.support}
                                        disabled
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <Select
                                        options={status}
                                        value={analyse.status}
                                        label={i18n.status}
                                        keyLabel='name'
                                        keyValue='code'
                                        disabled
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <Select
                                        options={qualifications}
                                        value={analyse.qualification}
                                        label={i18n.qualification}
                                        keyLabel='name'
                                        keyValue='code'
                                        disabled
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Select
                                        options={parameters}
                                        value={analyse.parameter}
                                        label={i18n.parameter}
                                        keyLabel={showSandreCode ? 'labelWithCode' : 'name'}
                                        disabled
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <Input
                                        title={i18n.result}
                                        value={analyse.result}
                                        disabled
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <Select
                                        options={units}
                                        value={analyse.unit}
                                        label={i18n.unit}
                                        keyLabel={showSandreCode ? 'symbolWithName' : 'symbol'}
                                        disabled
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <Select
                                        options={remarks}
                                        value={analyse.remark}
                                        label={i18n.remark}
                                        keyLabel='name'
                                        keyValue='code'
                                        disabled
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <Input
                                        title={i18n.quantificationLimit}
                                        value={analyse.lq}
                                        disabled
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Select
                                        options={laboratories}
                                        value={analyse.labo}
                                        label={i18n.laboratory}
                                        disabled
                                    />
                                </Grid>
                            </Grid>
                        </StyledFieldSet>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => dispatch(push(`/station/quality/${analyse.qualitometer}`))} variant='contained' color='primary'>
                    {i18n.accessToTheFile}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

SampleModal.propTypes = {
    isOpen: PropTypes.bool,
    close: PropTypes.func,
    analyse: PropTypes.shape({
        // DtoAnalysis
        // calculateThresholdsResult
    }),
}

export default SampleModal